import { useState, type ReactNode } from "react";
import { Check, Copy } from "lucide-react";

import { cn } from "@/lib/utils";

import { HoverHintContent } from "./title-help";

type CopyToClipboardGlyphProps = {
  text: string;
  /** Used in hover hint and aria-label, for example "MPN". */
  label?: string;
  className?: string;
};

export function CopyToClipboardGlyph({
  text,
  label = "text",
  className,
}: CopyToClipboardGlyphProps): ReactNode {
  const [copied, setCopied] = useState(false);
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  const hint = `Copy ${label} to clipboard`;

  return (
    <HoverHintContent hoverHint={hint} block>
      <button
        type="button"
        className={cn(
          "inline-flex shrink-0 rounded p-0.5 text-slate-400 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1",
          className,
        )}
        aria-label={hint}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          void navigator.clipboard.writeText(trimmed).then(
            () => {
              setCopied(true);
              window.setTimeout(() => setCopied(false), 1500);
            },
            () => {
              window.alert(`Could not copy ${label.toLowerCase()}.`);
            },
          );
        }}
      >
        {copied ? <Check className="h-3.5 w-3.5" aria-hidden /> : <Copy className="h-3.5 w-3.5" aria-hidden />}
      </button>
    </HoverHintContent>
  );
}
